import type { ComponentStatusOrUnknown, StatusSummary } from '@/shared/api';

export const STATUS_LABEL: Record<ComponentStatusOrUnknown, string> = {
  up: 'Работает',
  degraded: 'С перебоями',
  down: 'Сбой',
  unknown: 'Нет данных',
};

export const OVERALL_LABEL: Record<ComponentStatusOrUnknown, string> = {
  up: 'Всё работает',
  degraded: 'Есть перебои',
  down: 'Есть сбой',
  unknown: 'Состояние неизвестно',
};

export function problemsOf(summary: StatusSummary | null): StatusSummary['components'] {
  if (!summary) return [];
  return summary.components
    .filter((c) => c.status === 'down' || c.status === 'degraded')
    .sort((a, b) => (a.status === b.status ? 0 : a.status === 'down' ? -1 : 1));
}
